export default {
      id: "i-newspaper-usage",
      viewBox: "0 0 576 512",
      url: __webpack_public_path__ + "img/sprite.svg#i-newspaper",
      toString: function () {
        return this.url;
      }
    }